var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSystemInfoFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 1.333a6.668 6.668 0 1 1 0 13.335A6.668 6.668 0 0 1 8 1.333Zm-.003 5.5a.667.667 0 0 0-.662.59l-.004.077.002 3.668.005.078a.667.667 0 0 0 1.324-.001l.005-.078L8.664 7.5l-.004-.077a.667.667 0 0 0-.663-.589ZM8 4.333a.834.834 0 1 0 0 1.67.834.834 0 0 0 0-1.67Z",
  fill: "#9F9F9F"
})));
export default SvgIcSystemInfoFilled;